import { render, staticRenderFns } from "./EstadisticasComponent.vue?vue&type=template&id=5632174a&scoped=true"
import script from "./EstadisticasComponent.vue?vue&type=script&lang=js"
export * from "./EstadisticasComponent.vue?vue&type=script&lang=js"
import style0 from "./EstadisticasComponent.vue?vue&type=style&index=0&id=5632174a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5632174a",
  null
  
)

export default component.exports